"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _reactNotifications = require("react-notifications");
var _axios = _interopRequireDefault(require("axios"));
var _keycodeJs = require("keycode-js");
var _cache = require("@stt-componentes/cache");
var _fieldNames = require("../fieldNames");
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    form: {
      marginTop: "10px",
      marginBottom: "30px"
    },
    tableWrapper: {
      maxHeight: 440,
      overflow: "auto"
    },
    buttonWrapper: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      paddingTop: "2px"
    }
  };
});
var ORDENACAO = {
  DIRECAO: {
    ASC: "asc",
    DESC: "desc"
  },
  CAMPOS: {
    SIGLA: "id",
    DESCRITOR: "descritor",
    DESCRITOR_ANTECESSOR: "descritor_antecessor"
  }
};
var BuscaDecsTanstack = function BuscaDecsTanstack(props) {
  var strings = props.strings,
    handleAdd = props.handleAdd,
    open = props.open,
    setOpen = props.setOpen,
    multiplos = props.multiplos,
    tanStackForm = props.tanStackForm,
    form = props.form;
  var classes = useStyles();
  var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    texto = _useState2[0],
    setTexto = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    codigo = _useState4[0],
    setCodigo = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    listaDecs = _useState6[0],
    setListaDecs = _useState6[1];
  var _useState7 = (0, _react.useState)(global.gConfig.pagination.start),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  var _useState9 = (0, _react.useState)(global.gConfig.pagination.count),
    _useState0 = _slicedToArray(_useState9, 2),
    count = _useState0[0],
    setCount = _useState0[1];
  var _useState1 = (0, _react.useState)(ORDENACAO.DIRECAO.ASC),
    _useState10 = _slicedToArray(_useState1, 2),
    order = _useState10[0],
    setOrder = _useState10[1];
  var _useState11 = (0, _react.useState)(ORDENACAO.CAMPOS.DESCRITOR),
    _useState12 = _slicedToArray(_useState11, 2),
    orderBy = _useState12[0],
    setOrderBy = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    totalRegistros = _useState14[0],
    setTotalRegistros = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    buscando = _useState16[0],
    setBuscando = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    linhasPaginaMudou = _useState18[0],
    setLinhasPaginaMudou = _useState18[1];
  var handleClose = function handleClose() {
    setOpen(!open);
    reset();
  };
  var reset = function reset() {
    setTexto("");
    setCodigo("");
    setBuscando(false);
    setListaDecs([]);
    resetPageAndSort();
    setCount(global.gConfig.pagination.count);
  };
  var resetPageAndSort = function resetPageAndSort() {
    setPage(global.gConfig.pagination.start);
    setOrder(ORDENACAO.DIRECAO.ASC);
    setOrderBy(ORDENACAO.CAMPOS.DESCRITOR);
  };
  var handleChangeTexto = function handleChangeTexto(event) {
    setTexto(event.target.value);
  };
  var handleChangeCodigo = function handleChangeCodigo(event) {
    setCodigo(event.target.value.toUpperCase());
  };
  var handleClickBuscar = function handleClickBuscar() {
    resetPageAndSort();
    buscar(page);
  };
  var handleClickSort = function handleClickSort(campo) {
    var isAsc = orderBy === campo && order === ORDENACAO.DIRECAO.ASC;
    var newOrder = isAsc ? ORDENACAO.DIRECAO.DESC : ORDENACAO.DIRECAO.ASC;
    setOrder(newOrder);
    setOrderBy(campo);
    buscar(page);
  };
  var handleKeyUpTexto = function handleKeyUpTexto(event) {
    if (event.keyCode === _keycodeJs.KEY_RETURN && texto) {
      buscar(page);
    }
  };
  var handleKeyUpCodigo = function handleKeyUpCodigo(event) {
    if (event.keyCode === _keycodeJs.KEY_RETURN && codigo) {
      buscar(page);
    }
  };
  var buscar = function buscar(pagina) {
    setBuscando(true);
    var url = "".concat(UTILITARIOS_API_BASE_URL, "/decs");
    var offset = pagina * count;
    var params = {
      term: texto,
      id: codigo,
      start: offset,
      count: count,
      sort: orderBy,
      direction: order
    };
    var token = _cache.Cache.getAccessToken();
    var headers = {
      Authorization: "Bearer ".concat(token),
      "Content-Type": "application/json"
    };
    _axios["default"].get(url, {
      params: params,
      headers: headers
    }).then(function (response) {
      if (response.data) {
        var itens = response.data.data.itens;
        var total = response.data.data.totalRegistros;
        setTotalRegistros(parseInt(total));
        setListaDecs(itens);
      }
    })["catch"](function () {
      setListaDecs([]);
    })["finally"](function () {
      setBuscando(false);
      setLinhasPaginaMudou(false);
    });
  };
  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
    buscar(newPage);
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setCount(event.target.value);
    setPage(global.gConfig.pagination.start);
    setLinhasPaginaMudou(true);
  };
  (0, _react.useEffect)(function () {
    if (linhasPaginaMudou) {
      handleClickBuscar();
    }
  }, [linhasPaginaMudou]);
  return /*#__PURE__*/_react["default"].createElement(_core.SttModal, {
    title: "".concat(strings.buscar, " ").concat(strings.decs),
    open: open,
    outModalClose: handleClose,
    iconClose: handleClose,
    maxWidth: "lg",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.form
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 6
    }, /*#__PURE__*/_react["default"].createElement(_core.SttInput, {
      label: "Descritor",
      value: texto,
      onChange: handleChangeTexto,
      onKeyUp: handleKeyUpTexto
    })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 10,
      md: 4
    }, /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, {
      label: "C\xF3digo",
      mask: "decs",
      value: codigo,
      onChange: handleChangeCodigo,
      onKeyUp: handleKeyUpCodigo
    })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 2,
      md: 2
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.buttonWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "contained",
      color: "primary",
      nomarginleft: "true",
      onClick: handleClickBuscar
    }, strings.buscar))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.tableWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTable, {
      stickyHeader: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      smDown: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.SIGLA ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.SIGLA,
      direction: orderBy === ORDENACAO.CAMPOS.SIGLA ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.SIGLA);
      }
    }, strings.sigla)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "40%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.DESCRITOR ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.DESCRITOR,
      direction: orderBy === ORDENACAO.CAMPOS.DESCRITOR ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.DESCRITOR);
      }
    }, strings.descritor)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "40%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.DESCRITOR_ANTECESSOR ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.DESCRITOR_ANTECESSOR,
      direction: orderBy === ORDENACAO.CAMPOS.DESCRITOR_ANTECESSOR ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.DESCRITOR_ANTECESSOR);
      }
    }, strings.descritorAntecessor)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%"
    }, strings.selecionar)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      mdUp: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "100%",
      colSpan: "2"
    }, strings.decs)))), /*#__PURE__*/_react["default"].createElement(_core.SttTableBody, null, buscando ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 4,
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, null))) : listaDecs.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 4,
      align: "center"
    }, strings.nenhumResultado)) : listaDecs.map(function (row, index) {
      return /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        smDown: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.id), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.descritor), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.descritor_antecessor)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        mdUp: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        width: "96%"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.sigla, ":"), " ", row.id), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.descritor, ":"), " ", row.descritor), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.descritorAntecessor, ":"), " ", row.descritor_antecessor))), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        align: "center"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttAddButton, {
        id: "btn-confirmar-decs-".concat(index),
        onClick: function onClick() {
          var formValues = form.state.values[_fieldNames.FIELDS.DECS] || [];
          if (formValues.some(function (decs) {
            return decs.id == row.id;
          })) {
            _reactNotifications.NotificationManager.error(strings.decsAdicionadoAnteriormente);
          } else {
            handleAdd(row);
            if (!multiplos) {
              handleClose();
            }
            _reactNotifications.NotificationManager.success(strings.decsAdicionado);
          }
        }
      })));
    })))), listaDecs.length > 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTablePagination, {
      rowsPerPageOptions: [10, 20, 40],
      component: "div",
      count: totalRegistros,
      rowsPerPage: count,
      page: page,
      onPageChange: handleChangePage,
      onRowsPerPageChange: handleChangeRowsPerPage,
      labelRowsPerPage: "Linhas por p\xE1gina",
      labelDisplayedRows: function labelDisplayedRows(params) {
        return "".concat(params.from, "-").concat(params.to, " de ").concat(params.count);
      }
    }) : null),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "outlined",
      color: "primary",
      onClick: handleClose
    }, strings.fechar))
  });
};
var _default = exports["default"] = BuscaDecsTanstack;